import { DayOfWeek } from '@principle-theorem/shared';

// Ovie KnowledgeBasePushBody caps: exceeding these is rejected upstream with 400. Keep in sync with the API spec.
export const KNOWLEDGE_BASE_MAX_TEXT_LENGTH = 10_000;
export const KNOWLEDGE_BASE_MAX_AFTER_HOURS_MESSAGE_LENGTH = 400;
export const KNOWLEDGE_BASE_MAX_PUBLIC_HOLIDAY_NOTE_LENGTH = 1_000;
export const KNOWLEDGE_BASE_MIN_WINDOW_HOURS = 1;
export const KNOWLEDGE_BASE_MAX_WINDOW_HOURS = 8_760;

// KbQaPair: `q` and `a` are both minLength 1, so a blank pair is rejected outright.
export const KNOWLEDGE_BASE_MAX_QA_QUESTION_LENGTH = 120;
export const KNOWLEDGE_BASE_MAX_QA_ANSWER_LENGTH = 400;

export const KNOWLEDGE_BASE_MAX_TREATMENT_NAME_LENGTH = 200;
export const KNOWLEDGE_BASE_MAX_PRICE_RANGE_LENGTH = 100;
export const KNOWLEDGE_BASE_MAX_CUSTOM_SECTION_TITLE_LENGTH = 200;

// maxItems on every KbPushBody collection and on each sectionQaPairs key.
export const KNOWLEDGE_BASE_MAX_COLLECTION_ITEMS = 100;

// Notes per treatment: max 500 chars (Ovie KbTreatmentPricingItem.notes, api-1.json:4699).
export const KNOWLEDGE_BASE_MAX_TREATMENT_NOTES_LENGTH = 500;

export interface IKnowledgeBaseDayHours {
  open: string;
  close: string;
  isClosed: boolean;
}

export type IKnowledgeBaseBusinessHours = Record<
  DayOfWeek,
  IKnowledgeBaseDayHours
>;

export interface IKnowledgeBaseService {
  name: string;
  description?: string;
}

export interface IKnowledgeBaseSpecialisation {
  name: string;
  description?: string;
}

export interface IKnowledgeBaseTreatmentPricingItem {
  id: string;
  treatment: string;
  priceRange: string;
  notes?: string;
}

export interface IKnowledgeBaseQaPair {
  id: string;
  q: string;
  a: string;
}

export interface IKnowledgeBaseCustomSection {
  title: string;
  content: string;
  qa?: IKnowledgeBaseQaPair[];
}

export interface IKnowledgeBaseEmergencyHours {
  available: boolean;
  contact?: string;
  hours?: string;
}

export interface IKnowledgeBasePushBody {
  clinicName?: string;
  address?: string;
  phoneNumber?: string;
  email?: string;
  website?: string | null;
  businessHours?: IKnowledgeBaseBusinessHours;
  services?: IKnowledgeBaseService[];
  specializations?: IKnowledgeBaseSpecialisation[];
  treatmentPricing?: IKnowledgeBaseTreatmentPricingItem[] | null;
  emergencyContact?: string | null;
  emergencyHours?: IKnowledgeBaseEmergencyHours | null;
  practiceDescription?: string;
  generalServices?: string;
  cosmeticServices?: string;
  appointmentsBooking?: string;
  feesPayments?: string;
  parkingAccess?: string;
  ourTeam?: string;
  publicHolidayNote?: string;
  afterHoursMessage?: string;
  additionalInfo?: string;
  customSections?: IKnowledgeBaseCustomSection[] | null;
  sectionQaPairs?: Record<string, IKnowledgeBaseQaPair[]> | null;
  cancellationPolicy?: string | null;
  allowsCancellations?: boolean;
  cancellationFeeWindowHours?: number | null;
  allowsRescheduling?: boolean;
  reschedulingPolicy?: string | null;
  reschedulingWindowHours?: number | null;
}
